import React, { useEffect, useRef } from 'react';
const TextFieldGroup = ({ prefixCls, onBlur, children, ...otherProps }) => {
    const ref = useRef(null);
    useEffect(() => {
        const { current } = ref;
        if (current && onBlur) {
            const handleMousedown = (e) => {
                const { target } = e;
                if (!e.defaultPrevented && !current.contains(target)) {
                    onBlur(e);
                }
            };
            document.addEventListener('mousedown', handleMousedown, false);
            return () => {
                document.removeEventListener('mousedown', handleMousedown, false);
            };
        }
    }, [onBlur, ref]);
    return (React.createElement("div", Object.assign({ ref: ref, className: `${prefixCls}-group-wrapper` }, otherProps), children));
};
TextFieldGroup.displayName = 'TextFieldGroup';
export default TextFieldGroup;
